import { inject, Injectable } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { TitleStrategy, RouterStateSnapshot } from '@angular/router'
import { AppStoreService } from './core/app-state.service'
import { environment } from '../environments/environment'

@Injectable()
export class SurefirePageTitleStrategy extends TitleStrategy {
    appStore = inject(AppStoreService)

    constructor(private readonly title: Title) {
        super()
    }

    override updateTitle(routerState: RouterStateSnapshot) {
        const companyName = this.appStore.company()?.name ?? 'Surefire Software'

        const title = this.buildTitle(routerState)

        if (title !== undefined) {
            this.title.setTitle(`Surequote | ${companyName} - ${title}`)
        }

        if (!environment.production) {
            this.title.setTitle(`${this.title.getTitle()} (dev)`)
        }
    }
}
